import React, { useEffect, useState } from "react";
import TmsTable from "../../../../../components/tms-customs/tms-table.jsx";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router.jsx";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error.js";
import { Col, Drawer, Switch } from "antd";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-all.scss";
import TmsShivaDeekshaService from "../../../../../services/shiva-deeksha.service.js";
import ShivaDeekshaInnerActions from "../../../../../components/tms-service-management/sm-shiva-deeksha/shiva-deeksha-actions.jsx";
import ShivaDeekshaInnerPagesAND from "./shiva-deeksha-inner-pages-and.jsx";
const ShivaDeekshaInnerPagesAll = ({ router }) => {
  const [updateFlag, setUpdateFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tollgateData, setTollgateData] = useState([]);
  const [tmsModalVisible, settmsModalVisible] = useState(false);
  const [viewShivaDeekshaData, setViewShivaDeekshaData] = useState();
  const [editFlag, setEditFlag] = useState();
  const [productId, setProductId] = useState();
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);

  const tableColums = [
    ["Product type", viewShivaDeekshaData?.name],
    ["Description", viewShivaDeekshaData?.description],
    [
      "POS-(Status)",
      viewShivaDeekshaData?.counterEnabled ? "enabled" : "disabled",
    ],
    [
      "Online-(Status)",
      viewShivaDeekshaData?.onlineEnabled ? "enabled" : "disabled",
    ],
  ];

  const switchTrigger = async (key) => {
    setLoading(true);
    try {
      const tollData = await TmsShivaDeekshaService.viewShivaDeeksha(key);
      setViewShivaDeekshaData(tollData);
      settmsModalVisible(true);
      setEditFlag(true);
      setProductId(key);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    // try {
    //   const tollgateData = await TmsTollGateService.viewTollGate(key);
    //   let body = {
    //     name: tollgateData?.name,
    //     description: tollgateData?.description,
    //     counterEnabled:
    //       from === "counter" ? status : tollgateData?.counterEnabled,
    //     onlineEnabled: from === "online" ? status : tollgateData?.onlineEnabled,
    //     price: tollgateData?.price,
    //     imageUrl: tollgateData?.imageUrl,
    //     duration: tollgateData?.duration,
    //   };
    //   await TmsTollGateService.editTollGate(key, body);
    //   setUpdateFlag(Math.random() + 1);
    // } catch (error) {
    //   catchErrorFunction(
    //     error,
    //     "Token Expired, redirecting to login page in 5 seconds",
    //     router
    //   );
    // }
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  useEffect(() => {
    router.location?.pathname === "/service-management/shiva-deeksha" &&
      getAllShivaDeeksha();
    if (!editFlag) {
      settmsModalVisible(false);
    }
  }, [
    updateFlag,
    editFlag,
    tableCurrentPage,
    tablePageSize,
    router.location?.pathname,
  ]);

  const getAllShivaDeeksha = async () => {
    setLoading(true);
    try {
      let data = [];
      setTollgateData([]);

      data = await TmsShivaDeekshaService.getShivaDeeksha(
        tableCurrentPage,
        tablePageSize
      );

      setTabelTotalSize(data?.meta?.totalItems);
      setTollgateData(
        data?.items?.map((item) => {
          return {
            key: item.id,
            ...item,
          };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Bhavani Deeksha Name",
      dataIndex: "name",
      key: "name",
      //   ...getColumnSearchProps("darshanam_name"),
    },

    {
      title: "POS-(Status)",
      dataIndex: "counterEnabled",
      key: "counterEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{ background: text ? "#4CBB17" : "EFEFEF" }}
            onClick={() => {
              switchTrigger(record?.key, !text, "counter");
            }}
          />
        );
      },
    },
    {
      title: "Online-(Status)",

      dataIndex: "onlineEnabled",
      key: "onlineEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{
              background: text ? "#4CBB17 " : "EFEFEF ",
            }}
            onClick={() => {
              switchTrigger(record?.key);
            }}
          />
        );
      },
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <ShivaDeekshaInnerActions
            record={record}
            setLoading={setLoading}
            setViewShivaDeekshaData={setViewShivaDeekshaData}
            settmsModalVisible={settmsModalVisible}
            setUpdateFlag={setUpdateFlag}
            setEditFlag={setEditFlag}
            setProductId={setProductId}
          />
        );
      },
    },
  ];

  return (
    <>
      <TmsTable
        columns={columns}
        loading={loading}
        dataSource={tollgateData}
        handleTableChange={handleTableChange}
        pagination={{
          total: tableTotalSize,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
      />
      <Drawer
        className="DetailsModal"
        width={editFlag ? "800px" : "600px"}
        visible={tmsModalVisible}
        onClose={() => {
          settmsModalVisible(false);
          setEditFlag(false);
          setViewShivaDeekshaData(null);
        }}
        title={editFlag ? "Edit Bhavani Deeksha" : "Bhavani Deeksha Details"}
      >
        {editFlag ? (
          <ShivaDeekshaInnerPagesAND
            viewShivaDeekshaData={viewShivaDeekshaData}
            editFlag={editFlag}
            productId={productId}
            setEditFlag={setEditFlag}
            settmsModalVisible={settmsModalVisible}
          />
        ) : (
          <div className="viewDetails">
            <Col style={{ width: "100%" }}>
              <table className="DetailsTable">
                {tableColums.map((item) => {
                  return (
                    <tr key={"table" + item[0]}>
                      <th>{item[0]}</th>
                      <td>{item[1]}</td>
                    </tr>
                  );
                })}
              </table>
            </Col>
            <br />
            <Col className="ImgCol">
              <img src={viewShivaDeekshaData?.imageUrl} alt="Image" />
            </Col>
          </div>
        )}
      </Drawer>
      {/* <Drawer
        className="TermsDrawer"
        visible={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setTermsData([]);
          setOnlineTermsData([]);
        }}
        title="Terms & Conditions"
        extra={
          <Button
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                await TmsShivaDeekshaService.updateTerms(
                  productId,
                  termsData?.toString()?.replaceAll(",", "\n")?.split("\n"),
                  onlinetermsData
                    ?.toString()
                    ?.replaceAll(",", "\n")
                    ?.split("\n"),
                  miniTicket
                );
                setUpdateFlag(Math.random() + 1);
                setShowDrawer(false);
                setTermsData([]);
                setOnlineTermsData([]);
                setMiniTicket(false);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
          >
            Submit
          </Button>
        }
      >
        POS
        <TextArea
          maxLength={2200}
          rows={5}
          value={termsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setTermsData(e.target.value);
          }}
        />
        <br />
        <br />
        Online
        <TextArea
          maxLength={2200}
          rows={5}
          value={onlinetermsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setOnlineTermsData(e.target.value);
          }}
        />
        <Row className="formRow" style={{ width: "100%", paddingTop: "10px" }}>
          <Checkbox
            style={{ paddingRight: "10px" }}
            checked={miniTicket}
            onChange={(e) => setMiniTicket(e.target.checked)}
          />
          <label>Mini ticket</label>
        </Row>
      </Drawer> */}
    </>
  );
};

export default withRouter(ShivaDeekshaInnerPagesAll);
